import DealFilters from '@/components/all-from-router/_components/deal-filters/deal-filters';
import {
  FilteredDealsProvider,
  useFilteredDealsContext,
} from '@/components/all-from-router/_components/deal-filters/filtered-deals/filtered-deals-provider';
import VirtualizedDealStages from '@/components/stages-from-router/_components/virtualized-deal-stages';
import FindInViewFilter from '@/components/ui/find-in-view-filter/find-in-view-filter';
import { useFindInViewFilterContext } from '@/components/ui/find-in-view-filter/find-in-view-filter-provider';
import { HubListHeader } from '@/components/ui/layout/headers';
import HotkeyDialogBoxes from '@/components/ux/all-list-and-board/hotkey-dialog-boxes';
import useAllListAndBoardHotkeys from '@/components/ux/all-list-and-board/use-all-list-and-board-hotkeys';
import useDealsByStage from '@/hooks/use-deals-by-stage';
import { type DealListItem } from '@/models/types';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

export const Route = createFileRoute('/(authenticated)/$hub/contract-queue/')({
  component: AllPageWrapper,
  staticData: {
    keepAlive: true,
  },
});

const StagesPage = observer(() => {
  // const { dealsListData: dealsData } = useDealList();
  const { dealsByStageData: dealsData } = useDealsByStage();
  const { filterCallback, shouldApplyFilteredDealsIds } =
    useFilteredDealsContext();

  const { openDialog, setOpenDialog, selectedDeal, enableScope } =
    useAllListAndBoardHotkeys();

  const { findInViewQuery } = useFindInViewFilterContext();

  const findInViewFilterCallback = useCallback(
    (deal: DealListItem) => {
      const query = findInViewQuery.toLowerCase();
      const vin = deal.vehicle?.vehicle?.vin;

      return (
        deal.short_id.toLowerCase().includes(query) ||
        deal.customer_name?.toLowerCase().includes(query) ||
        deal.customer_email?.toLowerCase().includes(query) ||
        (vin ? vin.toLowerCase().includes(query) : false)
      );
    },
    [findInViewQuery],
  );

  return (
    <div className="flex flex-col">
      <HubListHeader
        findInViewFilter={<FindInViewFilter />}
        subRow={<DealFilters />}
      />

      <VirtualizedDealStages
        dealsData={dealsData}
        filterCallback={filterCallback}
        enableScope={enableScope}
        shouldApplyFilteredDealsIds={shouldApplyFilteredDealsIds}
        findInViewFilterCallback={findInViewFilterCallback}
      />

      <HotkeyDialogBoxes
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        selectedDeal={selectedDeal}
      />
    </div>
  );
});

function AllPageWrapper() {
  return (
    <FilteredDealsProvider>
      <StagesPage />
    </FilteredDealsProvider>
  );
}
